import { setState } from '../../../analytics-state';
import { setAnalytics, isDuplicatePageError, getContentProducts } from '../../../thd-analytics-utils';
import {
  MY_LIST_DETAILS,
  MY_LIST_DETAILS_PAGE_TYPE,
  MY_LIST_SHARED,
  MY_LIST_SUMMARY
} from '../../../constants';

/**
 * Safely converts a value to a number, defaulting to 0 for invalid values
 * @param {*} value - The value to convert
 * @returns {number} - A valid number or 0
 */
const safeNumber = (value) => {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};

export function myList() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('list-details.page-load', ({ output }) => {
    const pageType = MY_LIST_DETAILS_PAGE_TYPE;
    setState({ pageType });

    // Extract page information from eventData - use dynamic values from experience
    const getOrEmpty = (passedObject) => passedObject || {};
    const getOrDefaultString = (passedString, defaultString) => passedString || defaultString;
    const pageData = getOrEmpty(output?.page);
    const pageInfo = getOrEmpty(pageData.pageInfo);
    const category = getOrEmpty(pageData.category);

    digitalData.page = {
      pageInfo: {
        pageName: getOrDefaultString(pageInfo.pageName, MY_LIST_DETAILS),
        pageType
      },
      category: {
        primaryCategory: getOrDefaultString(category.primaryCategory, MY_LIST_DETAILS),
        subCategory1: getOrDefaultString(category.subCategory1, MY_LIST_DETAILS),
        subCategory2: getOrDefaultString(category.subCategory2, MY_LIST_DETAILS)
      }
    };

    // The data structure is: eventData.output.output.myList (double-nested output)
    const myListData = output?.output?.myList || output?.myList;

    if (myListData) {
      const myListPayload = {
        groupTotal: safeNumber(myListData.groupTotal),
        groupDetail: getOrDefaultString(myListData.groupDetail, ''),
        groupNames: getOrDefaultString(myListData.groupNames, ''),
        listTotal: safeNumber(myListData.listTotal),
        uniqueSkuCount: safeNumber(myListData.uniqueSkuCount),
        quantityTotal: safeNumber(myListData.quantityTotal),
        lineItemType: getOrDefaultString(myListData.lineItemType, '0>0')
      };

      digitalData.page = {
        ...digitalData.page,
        myList: myListPayload
      };
    }

    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('list-shared.page-load', () => {
    const pageType = MY_LIST_DETAILS_PAGE_TYPE;
    setState({ pageType });
    digitalData.page = {
      pageInfo: {
        pageName: MY_LIST_SHARED,
        pageType
      },
      category: {
        primaryCategory: MY_LIST_SHARED,
        subCategory1: MY_LIST_SHARED,
        subCategory2: MY_LIST_SHARED
      }
    };
    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('list-summary.page-load', () => {
    const pageType = 'maml: list index';
    setState({ pageType });
    digitalData.page = {
      pageInfo: {
        pageName: MY_LIST_SUMMARY,
        pageType
      },
      category: {
        primaryCategory: MY_LIST_SUMMARY,
        subCategory1: MY_LIST_SUMMARY,
        subCategory2: MY_LIST_SUMMARY
      }
    };
    setAnalytics(digitalData);
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('my-list.page-error', ({ output }) => {
    const {
      type = 'error',
      displayType = 'page',
      pageSection = '',
      message = '',
      code = ''
    } = output || {};

    const pageError = {
      type,
      displayType,
      pageSection,
      message,
      code
    };
    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });

  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('my-list.products-load', ({ output }) => {
    const { products } = output;
    digitalData.content = {
      ...digitalData.content,
      product: getContentProducts(products)
    };
  });
}